import { OfferType } from '@occc-app/offerValidationService/types';
import { Feature } from '@occc/utils-access-control';

export const mapFormTypeToPermission = {
  [OfferType.VoucheredGame]: Feature.GAME_EDIT,
  [OfferType.FreeGame]: Feature.GAME_EDIT,
  [OfferType.LoyaltyEvent]: Feature.LOYALTY_EVENT_EDIT,
  [OfferType.Award]: Feature.AWARD_EDIT,
  [OfferType.Offer]: Feature.OFFER_EDIT,
  [OfferType.Billboard]: Feature.OFFER_EDIT,
  [OfferType.Challenge]: Feature.OFFER_EDIT,
  [OfferType.ClubOrPunchcard]: Feature.OFFER_EDIT,
  [OfferType.ExternalFulfillment]: Feature.OFFER_EDIT,
  [OfferType.FuelRollback]: Feature.OFFER_EDIT,
  [OfferType.Promotion]: Feature.OFFER_EDIT,
  [OfferType.Reward]: Feature.OFFER_EDIT,
  [OfferType.Sweepstakes]: Feature.OFFER_EDIT,
  [OfferType.Promocodes]: Feature.OFFER_EDIT,
  [OfferType.StoredValue]: Feature.OFFER_EDIT,
};
